window.DrinkLab = window.DrinkLab || {};

(function () {
  const CFG = () => window.DrinkLab.SCORING_CONFIG;
  const PRODUCTS = () => window.DrinkLab.SHOPIFY_PRODUCTS;
  const CLASSIC_PRODUCTS = () => window.DrinkLab.CLASSIC_SODA_PRODUCTS || {};
  // A recipe's hero can be either a flavour syrup (SHOPIFY_PRODUCTS) or a
  // classic soda / concentrate (CLASSIC_SODA_PRODUCTS) — e.g. the Orange
  // Cream sodas built on LOCAL Orange Soda. Look in both, syrups first.
  function productEntry(key) { return (PRODUCTS() || {})[key] || CLASSIC_PRODUCTS()[key] || null; }

  const isDebug = () =>
    window.DrinkLab.__DEV_PREVIEW__ === true &&
    new URLSearchParams(window.location.search).get(window.DrinkLab.DEBUG_QUERY_PARAM) === 'true';

  function productAvailableFor(productKey, sugarFreeOnly) {
    const entry = productEntry(productKey);
    if (!entry) return false;
    if (sugarFreeOnly) return !!entry.sugarFree;
    return !!entry.regular;
  }

  function resolveHeroReference(productKey, sugarFreeOnly, sourceMap) {
    const entry = sourceMap ? sourceMap[productKey] : productEntry(productKey);
    if (!entry) return null;
    if (sugarFreeOnly && entry.sugarFree) return entry.sugarFree;
    if (!sugarFreeOnly && entry.regular) return entry.regular;
    return entry.regular || entry.sugarFree || null;
  }

  function hardFilter(recipes, intent, options) {
    options = options || {};
    const allowUntested = !!options.allowUntested;
    return recipes.filter((r) => {
      if (!allowUntested && r.testingStatus !== 'approved') return false;
      const compat = r.drinkCompatibility[intent.drinkType];
      if (!compat || compat === 0) return false;
      if (!productEntry(r.heroProductId)) return false;
      if (!productAvailableFor(r.heroProductId, false) && !productAvailableFor(r.heroProductId, true)) return false;
      if (intent.sugarFreeOnly && !productAvailableFor(r.heroProductId, true)) return false;
      if (intent.serve && intent.serve !== 'either' && r.serve.indexOf(intent.serve) === -1 && r.serve.indexOf('either') === -1) return false;
      if (intent.drinkType === 'cocktail') {
        if (!r.spirits || r.spirits.length === 0) return false;
        if (intent.spirit && intent.spirit !== 'any' && r.spirits.indexOf(intent.spirit) === -1 && r.spirits.indexOf('any') === -1) return false;
      }
      if (intent.excludedRecipeIds && intent.excludedRecipeIds.indexOf(r.id) !== -1) return false;
      return true;
    });
  }

  function passesHeroMatchProtection(recipe, intent) {
    if (!intent.tasteProfiles || intent.tasteProfiles.length === 0) return true;
    return intent.tasteProfiles.some((p) => recipe.primaryProfiles.indexOf(p) !== -1);
  }

  function scoreProfile(recipe, intent) {
    const cfg = CFG().tasteProfile;
    if (!intent.tasteProfiles || intent.tasteProfiles.length === 0) return 0;
    let score = 0;
    if (intent.tasteProfiles.length === 1) {
      const p = intent.tasteProfiles[0];
      if (recipe.primaryProfiles.indexOf(p) !== -1) score += cfg.singleSelected.primary;
      else if (recipe.secondaryProfiles.indexOf(p) !== -1) score += cfg.singleSelected.secondary;
    } else {
      intent.tasteProfiles.forEach((p) => {
        if (recipe.primaryProfiles.indexOf(p) !== -1) score += cfg.multiSelected.primaryEach;
        else if (recipe.secondaryProfiles.indexOf(p) !== -1) score += cfg.multiSelected.secondaryEach;
      });
    }
    return Math.min(score, cfg.max);
  }

  function scoreAdventure(recipe, intent) { return CFG().adventureMatrix[intent.adventure][recipe.adventure]; }

  function scoreTemperature(recipe, intent) {
    const cfg = CFG().temperature;
    if (!intent.serve) return 0;
    if (intent.serve === 'either') return cfg.userChoseEither;
    if (recipe.serve.indexOf(intent.serve) !== -1) return cfg.exact;
    if (recipe.serve.indexOf('either') !== -1) return cfg.recipeSupportsEither;
    return 0;
  }

  function scoreSpirit(recipe, intent) {
    if (intent.drinkType !== 'cocktail') return 0;
    const cfg = CFG().spirit;
    if (!intent.spirit || intent.spirit === 'any') return cfg.any;
    if (recipe.spirits.indexOf(intent.spirit) !== -1) return cfg.exact;
    if (recipe.spirits.indexOf('any') !== -1) return cfg.supportsSelectedAmongMultiple;
    return 0;
  }

  function scoreBranchIntent(recipe, intent) {
    const cfg = CFG().branchIntent;
    if (!intent.intentTags || intent.intentTags.length === 0) return 0;
    if (!recipe.intentTags || recipe.intentTags.length === 0) return 0;
    return intent.intentTags.some((t) => recipe.intentTags.indexOf(t) !== -1) ? cfg.exact : 0;
  }

  function scoreFamiliarity(recipe, intent) { return CFG().familiarity[intent.adventure][recipe.familiarity] || 0; }
  function scoreMerchandising(recipe) { return Math.min(recipe.merchandisingBoost || 0, CFG().merchandisingMax); }
  function scoreSeasonal(recipe) { return 0; }

  function scoreDiversity(recipe, intent) {
    const cfg = CFG().diversity;
    const shown = intent.shownRecipeIds || [];
    let penalty = 0;
    const idx = shown.lastIndexOf(recipe.id);
    if (idx !== -1) {
      const fromEnd = shown.length - 1 - idx;
      if (fromEnd === 0) penalty += cfg.shownLastResult;
      else if (fromEnd === 1) penalty += cfg.shownTwoResultsAgo;
      else if (fromEnd === 2) penalty += cfg.shownThreeResultsAgo;
    }
    const shownHeroes = (intent.shownHeroProductIds || []);
    if (shownHeroes.indexOf(recipe.heroProductId) !== -1) penalty += cfg.sameFlavourFamily;
    return penalty;
  }

  function scoreRecipe(recipe, intent) {
    const breakdown = {
      drink: (function () { const map = CFG().drinkCompatibility; return map[recipe.drinkCompatibility[intent.drinkType]] || 0; })(),
      profile: scoreProfile(recipe, intent),
      adventure: scoreAdventure(recipe, intent),
      temperature: scoreTemperature(recipe, intent),
      spirit: scoreSpirit(recipe, intent),
      branchIntent: scoreBranchIntent(recipe, intent),
      familiarity: scoreFamiliarity(recipe, intent),
      merchandising: scoreMerchandising(recipe),
      seasonal: scoreSeasonal(recipe),
      diversity: -scoreDiversity(recipe, intent)
    };
    breakdown.total = Object.keys(breakdown).reduce((sum, k) => sum + breakdown[k], 0);
    return breakdown;
  }

  function tieBreak(a, b, intent) {
    if (a.score.drink !== b.score.drink) return b.score.drink - a.score.drink;
    if (a.score.profile !== b.score.profile) return b.score.profile - a.score.profile;
    if (a.score.adventure !== b.score.adventure) return b.score.adventure - a.score.adventure;
    if (a.score.merchandising !== b.score.merchandising) return b.score.merchandising - a.score.merchandising;
    const shown = intent.shownRecipeIds || [];
    const aLast = shown.lastIndexOf(a.recipe.id);
    const bLast = shown.lastIndexOf(b.recipe.id);
    if (aLast !== bLast) return aLast - bLast;
    return a.recipe.id < b.recipe.id ? -1 : 1;
  }

  /**
   * Three-tier recommendation (spec update 2026-08-11): a completed quiz
   * should never dead-end in the customer-facing experience.
   *   Tier 1 "exact"          — existing hero-match-protection + threshold
   *                             logic, unchanged. Single result.
   *   Tier 2 "close_match"    — eligible (drink-type-compatible) recipes
   *                             exist but none cleared the exact-match bar.
   *                             Top 3 by score, offered as explicit choices,
   *                             never claimed as an exact match.
   *   Tier 3 "dash_favorites" — no eligible recipes at all for this
   *                             drinkType/intent (e.g. Sugar-Free emptied
   *                             the pool). Curated per-drinkType fallback
   *                             list from fallbackRecipes.js — never
   *                             crosses drink categories, still respects
   *                             Sugar-Free and approval status.
   * Returns resultType: 'exact' | 'close_match' | 'dash_favorites' | null.
   * null only when even the curated fallback has nothing usable — reason
   * stays available for the debug panel either way.
   */
  function recommend(intent, options) {
    options = options || {};
    const allowUntested = isDebug() && options.allowUntested !== false;
    const eligible = hardFilter(window.DrinkLab.RECIPES, intent, { allowUntested });

    const ranked = eligible
      .map((recipe) => ({ recipe, score: scoreRecipe(recipe, intent) }))
      .sort((a, b) => {
        const diff = b.score.total - a.score.total;
        if (Math.abs(diff) <= window.DrinkLab.TIE_BREAK_MARGIN) return tieBreak(a, b, intent);
        return diff;
      });

    // Tier 1: Exact Match
    const winnerIdx = ranked.findIndex((e) => passesHeroMatchProtection(e.recipe, intent));
    if (winnerIdx !== -1) {
      const promoted = ranked.slice();
      if (winnerIdx > 0) { const [w] = promoted.splice(winnerIdx, 1); promoted.unshift(w); }
      const winner = promoted[0];
      if (winner && winner.score.total >= window.DrinkLab.MINIMUM_RECOMMENDATION_SCORE) {
        const hero = resolveHeroReference(winner.recipe.heroProductId, intent.sugarFreeOnly);
        return { resultType: 'exact', result: winner, hero, runnerUps: promoted.slice(1, 3), ranked: promoted, reason: null };
      }
    }

    // Tier 2: Close Matches — eligible pool is non-empty, just nothing hit
    // the exact-match bar. Not hero-match-protected on purpose: these are
    // explicitly offered as "closest", not claimed as exact.
    if (ranked.length > 0) {
      const candidates = ranked.slice(0, 3).map((entry) => ({
        recipe: entry.recipe,
        score: entry.score,
        hero: resolveHeroReference(entry.recipe.heroProductId, intent.sugarFreeOnly)
      }));
      return {
        resultType: 'close_match',
        candidates,
        ranked,
        reason: winnerIdx === -1 ? 'no_hero_match' : 'below_threshold'
      };
    }

    // Tier 3: Dash's Lab Favourites — curated fallback, same drinkType only
    const fallbackIds = (window.DrinkLab.FALLBACK_RECIPES && window.DrinkLab.FALLBACK_RECIPES[intent.drinkType]) || [];
    const fallbackCandidates = fallbackIds
      .map((id) => (window.DrinkLab.RECIPES || []).find((r) => r.id === id))
      .filter((r) => r && (r.testingStatus === 'approved' || allowUntested))
      .filter((r) => productAvailableFor(r.heroProductId, false) || productAvailableFor(r.heroProductId, true))
      .filter((r) => !intent.sugarFreeOnly || productAvailableFor(r.heroProductId, true))
      .slice(0, 3)
      .map((recipe) => ({ recipe, hero: resolveHeroReference(recipe.heroProductId, intent.sugarFreeOnly) }));

    if (fallbackCandidates.length > 0) {
      return { resultType: 'dash_favorites', candidates: fallbackCandidates, ranked: [], reason: 'no_eligible_recipes' };
    }

    // True dead end: no eligible recipes AND no usable curated fallback.
    // Debug info (reason) stays available; this is expected to be rare to
    // never in normal operation now that tiers 2/3 exist.
    return { resultType: null, result: null, ranked: [], reason: 'no_eligible_recipes_and_no_fallback' };
  }

  function recommendClassicSoda(intent) {
    let candidates = window.DrinkLab.CLASSIC_SODAS.filter((s) => {
      if (intent.sugarFreeOnly) {
        const p = window.DrinkLab.CLASSIC_SODA_PRODUCTS[s.productKey];
        return !!(p && p.sugarFree);
      }
      return true;
    });

    const cfg = CFG().classicSoda;
    const scored = candidates.map((soda) => {
      let vibeScore = 0;
      if (intent.intentTags && intent.intentTags.some((t) => soda.vibeTags.indexOf(t) !== -1)) vibeScore = cfg.categoryVibeMax;
      let tasteScore = 0;
      if (intent.tasteProfiles && intent.tasteProfiles.length) {
        const matches = intent.tasteProfiles.filter((p) => soda.profiles.indexOf(p) !== -1).length;
        tasteScore = Math.min((matches / intent.tasteProfiles.length) * cfg.tasteMax, cfg.tasteMax);
      }
      const famMap = { 1: cfg.familiarityMax, 2: cfg.familiarityMax * 0.7, 3: cfg.familiarityMax * 0.4, 4: cfg.familiarityMax * 0.1, 5: 0 };
      const familiarityScore = famMap[soda.familiarity] || 0;
      return { soda, total: vibeScore + tasteScore + familiarityScore };
    }).sort((a, b) => b.total - a.total);

    const winner = scored[0];
    if (!winner) return { result: null };
    const productRef = resolveHeroReference(winner.soda.productKey, intent.sugarFreeOnly, window.DrinkLab.CLASSIC_SODA_PRODUCTS);
    return { result: winner.soda, product: productRef, ranked: scored };
  }

  function resolveLabPack(labPackId, intent, excludeHeroKey) {
    const pack = window.DrinkLab.LAB_PACKS[labPackId];
    if (!pack) return null;
    const pickAvailable = (key) => {
      if (key === excludeHeroKey) return null;
      return productAvailableFor(key, false) || productAvailableFor(key, true) ? key : null;
    };
    let picks = pack.primary.map(pickAvailable).filter(Boolean);
    if (picks.length < 3) {
      const needed = 3 - picks.length;
      const fallbackPicks = pack.fallback.map(pickAvailable).filter(Boolean).slice(0, needed);
      picks = picks.concat(fallbackPicks);
    }
    if (picks.length < 3) return { pack, productKeys: picks, incomplete: true };
    return { pack, productKeys: picks.slice(0, 3), products: picks.slice(0, 3).map((key) => ({ key, ref: resolveHeroReference(key, intent.sugarFreeOnly) })) };
  }

  /**
   * Search by Flavour (added 2026-08-11): a second, independent discovery
   * mode alongside the quiz, for customers who already know which SIMPS
   * syrup they own. `productKey` must come from the retail allowlist
   * (window.DrinkLab.SHOPIFY_PRODUCTS — already excludes wholesale, cases,
   * BIBs, Recharge, Signature bundles, and pump packs by construction).
   *
   * Returns every recipe that uses the flavour, ranked:
   *   1. 'hero'       — the flavour is the recipe's hero product
   *   2. 'ingredient' — the flavour is a required (non-optional) ingredient
   *                     with a matching productId, but not the hero
   *                     (e.g. SIMPS Margarita Mix alongside a Prickly Pear
   *                     hero in DL-030)
   *   3. 'upgrade'    — the flavour appears only as an optional Dash's
   *                     Upgrade
   *
   * Applies the same production-safety gates as the quiz: testingStatus
   * ('approved' only, unless dev-preview debug mode), hero product must
   * resolve to a real SHOPIFY_PRODUCTS entry, and Sugar-Free availability
   * is checked against the recipe's hero exactly as hardFilter does (the
   * same scope the quiz already uses — this doesn't introduce a new rule).
   */
  function searchByFlavour(productKey, options) {
    options = options || {};
    const allowUntested = isDebug() && options.allowUntested !== false;
    const sugarFreeOnly = !!options.sugarFreeOnly;

    const matches = [];
    (window.DrinkLab.RECIPES || []).forEach((recipe) => {
      if (!allowUntested && recipe.testingStatus !== 'approved') return;
      if (!productEntry(recipe.heroProductId)) return;
      if (!productAvailableFor(recipe.heroProductId, false) && !productAvailableFor(recipe.heroProductId, true)) return;
      if (sugarFreeOnly && !productAvailableFor(recipe.heroProductId, true)) return;

      let tier = null;
      if (recipe.heroProductId === productKey) {
        tier = 'hero';
      } else if ((recipe.ingredients || []).some((ing) => ing.productId === productKey && !ing.optional)) {
        tier = 'ingredient';
      } else if (recipe.dashUpgrade && recipe.dashUpgrade.productId === productKey) {
        tier = 'upgrade';
      }
      if (!tier) return;

      const hero = resolveHeroReference(recipe.heroProductId, sugarFreeOnly);
      matches.push({ recipe, tier, hero });
    });

    const tierOrder = { hero: 0, ingredient: 1, upgrade: 2 };
    matches.sort((a, b) => {
      const diff = tierOrder[a.tier] - tierOrder[b.tier];
      if (diff !== 0) return diff;
      return a.recipe.name.localeCompare(b.recipe.name);
    });

    return matches;
  }

  window.DrinkLab.Engine = {
    hardFilter, scoreRecipe, recommend, recommendClassicSoda, resolveHeroReference, resolveLabPack,
    passesHeroMatchProtection, searchByFlavour, productAvailableFor, isDevPreviewDebug: isDebug
  };
})();